import { render, staticRenderFns } from "./ResultsListSection.vue?vue&type=template&id=001d08ab&scoped=true&"
import script from "./ResultsListSection.vue?vue&type=script&lang=js&"
export * from "./ResultsListSection.vue?vue&type=script&lang=js&"
import style0 from "./ResultsListSection.vue?vue&type=style&index=0&id=001d08ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001d08ab",
  null
  
)

export default component.exports